module.exports = __webpack_public_path__ + "static/img/integate-banner3.b991007.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/integate-banner3.png
// module id = MRN9
// module chunks = 31